import React from "react";
import { useTranslation } from "react-i18next";
import { track } from "@/api/analytics";

/**
 * Inline, editorial language toggle.
 * Renders three uppercase language codes separated by hairline dividers.
 * The active language is bronze; the others are subtle ink-300 → tap to switch.
 */
const LANGS = ["it", "en", "de"];

export default function LanguageSwitch() {
  const { i18n, t } = useTranslation();
  const current = LANGS.includes(i18n.language) ? i18n.language : "it";

  const change = (code) => {
    if (code === current) return;
    i18n.changeLanguage(code);
    localStorage.setItem("lp_lang", code);
    track("click_language_switch", { meta: { to: code } });
  };

  return (
    <div
      data-testid="language-switch"
      role="group"
      aria-label={t("common.language")}
      className="flex items-center gap-2 text-[10px] font-semibold tracking-overline select-none"
    >
      {LANGS.map((code, i) => (
        <React.Fragment key={code}>
          {i > 0 && <span aria-hidden className="text-ink-200">·</span>}
          <button
            type="button"
            onClick={() => change(code)}
            data-testid={`language-option-${code}`}
            aria-pressed={current === code}
            aria-label={code.toUpperCase()}
            className={`transition-colors ${
              current === code
                ? "text-bronze-500"
                : "text-ink-300 hover:text-ink-700"
            }`}
          >
            {code.toUpperCase()}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
}
